export default __webpack_public_path__ + "static/media/springSecurity.bff2ca16.png";